module.exports = __webpack_public_path__ + "static/horse-5ead2ee8359a99a7da51e3042614d1ea.svg";